<template>
  <div v-if="isMaintance">
    <maintance />
  </div>

  <template v-else>
    <NuxtLoadingIndicator color="#FE0000" />
    <NuxtLayout>
  <ClientOnly>
    <VitePwaManifest />
    <PwaUpdate />
    <InstallPrompt />
  </ClientOnly>
  <NuxtPage />
</NuxtLayout>
  </template>
</template>

<script setup>

useHead({
  link: [
    { 
      rel: 'icon', 
      type: 'image/x-icon', 
      href: '/favicon.ico' 
    },
    { 
      rel: 'apple-touch-icon', 
      sizes: '180x180', 
      href: '/apple-touch-icon.png' 
    }
  ],
  meta: [
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    { name: 'apple-mobile-web-app-title', content: 'Fiatre' },
  ],
  link: [
    { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' }
  ]
})

import maintance from './components/core/maintance.vue';


const isMaintance = false;

const nuxtApp = useNuxtApp();
const userStore = useUserStore();
const router = useRouter();

if (userStore.isAuthenticated) {
  await userStore.profileGetRequest.execute();
}

// Function to handle scrolling
const scrollToTop = () => {
  // Try multiple scroll methods
  window.scrollTo(0, 0);
  document.documentElement.scrollTo(0, 0);
  document.body.scrollTo(0, 0);

  // Fallback smooth scroll
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, 0);
};

// Router navigation handler
router.beforeEach((to, from, next) => {
  next();
  scrollToTop();
});

// Page finish handler
nuxtApp.hook('page:finish', () => {
  scrollToTop();
});

// Component mounted handler
onMounted(() => {
  scrollToTop();
});

// Watch route changes
watch(
  () => router.currentRoute.value.path,
  () => {
    scrollToTop();
  }
);
</script>

<style>
/* / */
</style>
